module.exports = __webpack_public_path__ + "img/kv.ef151a49.png";